module.exports = __webpack_public_path__ + "static/media/paper-plane.65ed9333.svg";